import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

// @see https://www.mlb.com/glossary/standard-stats/strikeout
// @see https://en.wikipedia.org/wiki/Strikeout#Rules_and_jargon
// A strikeout occurs when a pitcher throws any combination of three swinging or looking strikes to a hitter. (A foul ball counts as a strike, but it cannot be the third and final strike of the at-bat. A foul tip, which is caught by the catcher, is considered a third strike.)
const classifiesAsStrikeout = function(paResult) {
    switch (paResult) {
        case PlateAppearanceResult.CalledStrikeout.key:
        case PlateAppearanceResult.SwingingStrikeout.key:
        case PlateAppearanceResult.WildPitch.key: // @see https://baseball.fandom.com/wiki/Wild_pitch and https://www.baseballbible.net/dropped-third-strike-rule/
        case PlateAppearanceResult.PassedBall.key: // @see https://baseball.fandom.com/wiki/Passed_ball and https://www.baseballbible.net/dropped-third-strike-rule/
        case PlateAppearanceResult.FoulTipOut.key: // @see https://baseball.fandom.com/wiki/Foul_tip https://www.reddit.com/r/baseball/comments/898vw0/is_a_strikeout_on_a_foul_tip_considered_a/
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsStrikeout;